type TriangleDownProps = {
  className?: string;
  fill?: string;
};

const TriangleDown = ({ className, fill }: TriangleDownProps) => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      id="Triangle Down"
      d="M6.25259 8.15917L0.479435 1.66436C-0.0938109 1.01946 0.363995 0 1.22684 0H12.7732C13.636 0 14.0938 1.01946 13.5206 1.66436L7.74741 8.15917C7.34962 8.60668 6.65038 8.60668 6.25259 8.15917Z"
      fill={fill}
    />
  </svg>
);

export default TriangleDown;
